var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 7.659.542.661 1.265-.36 1.205.602 1.807 3.253 4.216 4.579-.542 1.024H8.29l-.904.723v.663l.602.904-3.313 4.578H3.048l1.627 1.386 4.156-4.156 2.17 2.952.542-2.048-1.024-.904-.723-1.205 1.747-2.17 6.326-1.325h3.493l1.387.603v2.289l1.265 3.132-2.65 2.83-1.326.422 1.988.904.301-.904 3.193-3.253-.843-4.037 3.915 2.711.723.904.422 2.951-.783 1.084H31l-.843-5.904c-.904-.723-2.711-2.3-2.711-2.831 0-.664-.482-.965-.844-2.893-.36-1.927-.843-2.47-1.927-3.313-1.085-.843-.904-1.626-1.386-2.47-.483-.843-1.808-1.988-2.41-1.928-.482.049-1.727 1.868-2.29 2.772h-.722c-.282-1.225-1.013-3.675-1.687-3.675s-1.485 1.406-1.807 2.108c-.32.985-1.638 2.893-4.337 2.652-2.699-.24-3.132-1.868-3.012-2.65.12-.543.12-1.724-.843-2.11-.963-.385-1.726-.16-1.987 0H2.807L1 7.66z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDx);
export default __webpack_public_path__ + "static/media/DX.1ed35ca8733a656746290b192d704295.svg";
export { ForwardRef as ReactComponent };